import { ReloadOutlined } from '@ant-design/icons';
import { Button, Collapse } from 'antd';
import { useParams } from 'react-router';

import {
  type IParticipantsImportsResponse,
  useLazyGetSchoolParticipantsImportsListQuery,
} from '@/api/endpoints/schools/schoolParticipants';
import { useApiRequest } from '@/shared/hooks';

import { ImportsStat } from './_components/ImportsStat/ImportsStat';
import { getAccordionItems } from './helpers';
import styles from './ParticipantsImportHistory.module.scss';

interface IProp {
  importsData: IParticipantsImportsResponse;
}

export const ParticipantsImportHistory = ({ importsData: { data: importsData, meta: importsMeta } }: IProp) => {
  const { id: schoolId } = useParams();

  const [getParticipantsImports] = useLazyGetSchoolParticipantsImportsListQuery();

  const accordionItems = getAccordionItems({ importsData });

  const sendApiRequest = useApiRequest();

  const resetHandle = () => {
    sendApiRequest({
      apiRequestCallback: () => getParticipantsImports({ schoolId: Number(schoolId) }),
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles['header-wrapper']}>
        <div className={styles['title-wrapper']}>
          <p className={styles.title}>История импортов</p>
          <Button
            icon={<ReloadOutlined />}
            shape="circle"
            size="small"
            onClick={resetHandle}
          />
        </div>
        <p>Просмотр всех выполненных операций импорта участников</p>
      </div>
      <Collapse
        ghost
        expandIconPlacement="end"
        accordion
        items={accordionItems}
      />
      <ImportsStat stats={importsMeta.stats} />
    </div>
  );
};
